import { render } from "./GroupPassingsTable.vue?vue&type=template&id=c8398a4a&scoped=true"
import script from "./GroupPassingsTable.vue?vue&type=script&lang=js"
export * from "./GroupPassingsTable.vue?vue&type=script&lang=js"

import "./GroupPassingsTable.vue?vue&type=style&index=0&id=c8398a4a&lang=scss"
import "./GroupPassingsTable.vue?vue&type=style&index=1&id=c8398a4a&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8398a4a"]])

export default __exports__